import { generateId } from 'shared/entities/common/utils';
import { apiUrls } from 'shared/entities/domain';
import { IRootStore } from 'shared/entities/store/rootStore';
import { UserPaymentCommonMethodServer } from 'shared/entities/userPayment';
import { validateIsEmpty } from 'shared/entities/validator';
import { FieldModel } from 'shared/models/form';

import { LoadingStageModel } from '../loadingStage';

export class NotConnectedCloudPaymentsMethod {
  readonly id: string;
  readonly publicKey: FieldModel = new FieldModel<string>('', [
    validateIsEmpty
  ]);
  readonly secretKey: FieldModel = new FieldModel<string>('', [
    validateIsEmpty
  ]);
  readonly creatingStage: LoadingStageModel = new LoadingStageModel();
  readonly rootStore: IRootStore;

  constructor({ id }: { id: string }, rootStore: IRootStore) {
    this.id = id;
    this.rootStore = rootStore;
  }

  create = async (): Promise<BaseResponse<UserPaymentCommonMethodServer>> => {
    if (
      this.creatingStage.isLoading ||
      this.publicKey.isError ||
      this.secretKey.isError
    ) {
      return {
        isError: true
      };
    }
    this.creatingStage.loading();

    const response =
      await this.rootStore.networkStore.api<UserPaymentCommonMethodServer>(
        apiUrls.OAUTH_CLOUDPAYMENTS_OBTAIN_SECRET,
        {
          method: 'POST',
          data: {
            public_id: this.publicKey.value,
            secret_key: this.secretKey.value
          }
        }
      );

    if (response.isError) {
      this.creatingStage.error();

      return {
        isError: true
      };
    } else {
      this.creatingStage.success();

      return {
        isError: false,
        data: response.data
      };
    }
  };

  static fromDefaultParams(
    rootStore: IRootStore
  ): NotConnectedCloudPaymentsMethod {
    return new NotConnectedCloudPaymentsMethod({ id: generateId() }, rootStore);
  }
}
